<template>
    <BasicDialog class="offerwall-dialog">
        <iframe :src="providerUrl" v-if="network.name !== NetworkNames.POLLFISH" class="w-100 h-100 rounded-12"
            frameborder="0" style="z-index: 0; height: 85vh !important;"></iframe>
        <v-container v-else class="d-flex align-center justify-center h-100">
            <v-row no-gutters class="d-flex align-center justify-center" style="height: 85vh">
                <v-btn @click="OpenPollfishOfferWall()">Open PollFish offer wall</v-btn>
            </v-row>
        </v-container>
    </BasicDialog>
</template>



<script setup>
import { computed } from 'vue';
import { useUserStore } from '@/store/UserStore';
import BasicDialog from '@/components/Common/Basic-Dialog.vue';
import { NetworkNames } from '@/constants/Networks/NetworkNames.ts';

const props = defineProps({
    network: {
        type: Object,
        required: true
    }
});

const userStore = useUserStore();
const userId = computed(() => userStore.user.id);
const networkDetails = computed(() => props.network);

const providerUrl = computed(() => {
    return props.network.getWallURLByUserId(userId.value);
});

const OpenPollfishOfferWall = () => {
    networkDetails.value.getWallURLByUserId(userId.value);
};

</script>

<style >
.offerwall-dialog {
    width: 100% !important;
}
</style>